module.exports = __webpack_public_path__ + "female-avatar.png?5522155776f935b968ee033b378c7dce";


//////////////////
// WEBPACK FOOTER
// ./src/assets/female-avatar.png
// module id = 597
// module chunks = 0